// extracted by mini-css-extract-plugin
export var wrapper = "Projects-module--wrapper--dda6f";
export var container = "Projects-module--container--9a264";
export var layout = "Projects-module--layout--106dd";
export var subtitle = "Projects-module--subtitle--80149";
export var sliderWrapper = "Projects-module--sliderWrapper--bb01d";
export var slide = "Projects-module--slide--1b3d2";
export var animation = "Projects-module--animation--3fc76";
export var formLayout = "Projects-module--formLayout--a3145";
export var formContent = "Projects-module--formContent--bc448";
export var formTitle = "Projects-module--formTitle--53ef5";
export var formWrapper = "Projects-module--formWrapper--2f3c0";